import { GetRequest, PostRequest, PostRequestCachedV3, PostRequestV2 } from '../../components/common/api'
import { getBaseUserId } from '../../components/common/helper'
import * as iid from '../../components/common/bookingElementId'
import { urls } from '../../components/common/constants'
import * as types from './action_types'
import * as type from '../action_types'

export function updateLoader(data) {
  return {
    type: type.LOADER,
    data,
  }
}

export const updateModal = (data, modalType) => {
  return {
    type: type.MODAL,
    data,
    modalType,
  }
}

export const updateSelectedActivity = (data) => {
  return {
    type: type.SELECTED_ACTIVITY,
    data,
  }
}

export const updateDispatchBranches = (data) => {
  return {
    type: types.DISPATCH_FROM_BRANCH,
    data,
  }
}

export const updateSelectVehicle = (data) => {
  return {
    type: types.Dispatch_SELECT_VEHICLE,
    data,
  }
}

export const updateShowListData = (data) => {
  return {
    type: types.Dispatch_SHOWLIST_DATA,
    data,
  }
}

export const updateReceive = (data) => {
  return {
    type: types.Dispatch_RECEIVE,
    data,
  }
}

export const updateShortReceive = (data) => {
  return {
    type: types.Dispatch_SHORT_RECEIVE,
    data,
  }
}
export const updateReceiveItemList = (data) => {
  return {
    type: types.Dispatch_RECEIVE_ITEMLIST,
    data,
  }
}
//All action of Branch Transfer End

//All Action Of Receive
export const updateReceiveDispatchCities = (data) => {
  return {
    type: types.RECEIVE_DISPATCH_FROM_CITY,
    data,
  }
}
export const updateReceiveSelectVehicle = (data) => {
  return {
    type: types.RECEIVE_DISPATCH_SELECT_VEHICLE,
    data,
  }
}
export const updateReceiveVehicleLoad = (data) => {
  return {
    type: types.RECEIVE_DISPATCH_LOAD_VEHICLE,
    data,
  }
}

export const updateReceiveChallan = (data) => {
  return {
    type: types.RECEIVE_DISPATCH_CHALLAN_NO,
    data,
  }
}

export const updateReceiveShowListData = (data) => {
  return {
    type: types.DISPATCH_RECEIVE_SHOWLIST_DATA,
    data,
  }
}
export const updateReceiveItemData = (data) => {
  return {
    type: types.Dispatch_RECEIVE_DATALIST,
    data,
  }
}
export const ReceiveUpdateReceive = (data) => {
  return {
    type: types.Dispatch_RECEIVE_RECEIVE,
    data,
  }
}
export const updateReceiveLRList = (data) => {
  return {
    type: types.Dispatch_RECEIVE_LRLIST,
    data,
  }
}
export const updateLuggageToReceive = (data) => {
  return {
    type: types.Dispatch_RECEIVE_LUGGAGETORECEIVE,
    data,
  }
}
export const updateReceiveSecond = (data) => {
  return {
    type: types.Dispatch_RECEIVE_SECOND,
    data,
  }
}
export const updateReceiveLastReceivePrint = (data) => {
  return {
    type: types.RECEIVE_LASTRECEIVE_PRINT,
    data,
  }
}
export const updateBranchReceiveLastReceivePrint = (data) => {
  return {
    type: types.BRANCHRECEIVE_LASTRECEIVE_PRINT,
    data,
  }
}
//All action of Receive End
export const getUpdateDispatchBranch = (loginData, data, isCache = false, cacheDuration = 0) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getDispatchBranches, {
    CompanyID: loginData.intCompanyID,
    UserID: loginData.intUserID,
    CityID: loginData.intBranchCityID,
    BranchID: loginData.intBranchID,
    // CityID: data.CityID,
    // BranchID: data.BranchID,
    Mode: 1,
  }, isCache, cacheDuration)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateDispatchBranches(res))
      } else {
        dispatch(updateDispatchBranches([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getUpdateSelectVehicle = (loginData, data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.getVehilceList, {
    intCompanyID: loginData.intCompanyID,
    intFromCityID: data.FromBranchID,
    intToCityID: data.intToCityID,
    dtJdate: '',
    intMode: 600,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateSelectVehicle(res))
      } else {
        dispatch(updateSelectVehicle([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getUpdateSHowListData = (loginData, data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.getShowlistData, {
    intFromBranchID: data.intFromBranchID,
    intToBranchID: data.intToBranchID,
    intCompanyID: loginData.intCompanyID,
    strVehicleNo: data.strVehicleNo,
    intIsInMovement: 1,
    intMode: 1,
    intVoucherNo: data.intVoucherNo,
    intVehicleID: data.intVehicleID,
    dtDate: data.dtDate,
    intConsignmentID: data.intConsignmentID,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.Success == true) {
        dispatch(updateShowListData(res.Data))
      } else {
        dispatch(updateShowListData([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getUpdateReceive = (loginData, data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.getReceive, {
    intBranchReceiptID: 0,
    intSendingCityID: data.intSendingCityID,
    intReceivedCityID: data.intReceivedCityID,
    intSendingBranchID: data.intSendingBranchID, //select branch
    intReceivedBranchID: data.intReceivedBranchID,
    strVehicleNo: data.strVehicleNo,
    strRemarks: data.strRemarks,
    intCompanyID: loginData.intCompanyID,
    intUserID: loginData.intUserID,
    intVehicleID: data.intVehicleID,
    strBranchTransferIDs: data.strBranchTransferIDs,
    strBranchTransferDetIDs: data.strBranchTransferDetIDs,
    strLRNos: data.strLRNos,
    strShortQtys: data.strShortQtys,
    strDamageQtys: data.strDamageQtys,
    strBookingIDs: data.strBookingIDs,
    intIsApp: 2,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == true) {
        dispatch(updateReceive(res))
      } else {
        dispatch(updateReceive(res))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getUpdateReceiveV2 = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.getReceiveV2, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateReceive(res))
      } else {
        dispatch(updateReceive(res))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}


export const getUpdateShortReceive = (loginData, data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.getCancelTransfer, {
    strBookingIDs: data.strBookingIDs,
    strBranchTransferIDS: data.strBranchTransferIDS,
    intIsShortReceipt: 1,
    intUserID: loginData.intUserID,
    BaseUserId: getBaseUserId(loginData.intUserID),
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == true) {
        dispatch(updateShortReceive(res))
      } else {
        dispatch(updateShortReceive(res))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getUpdateReceiveItemList = (loginData, data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getReceiveItemList, {
    intSendingBranchID: data.intSendingBranchID,
    intReceivedBranchID: data.intReceivedBranchID,
    // intSendingBranchID:0,
    // intReceivedBranchID:1,
    intBranchID: loginData.intBranchID,
    intCompanyID: loginData.intCompanyID,
    DateFrom: data.DateFrom,
    DateTo: data.DateTo,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateReceiveItemList(res))
      } else {
        dispatch(updateReceiveItemList([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

//All Action Of Receive

export const getUpdateReceiveDispatchCity = (loginData, data, isCache = false, cacheDuration = 0) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequestCachedV3(urls.getReceiveDispatchCitiesBranches, {
    intCompanyID: loginData.intCompanyID,
    intUserID: loginData.intUserID,
    intBranchID: data.BranchID,
  }, isCache, cacheDuration)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        const data=res.cities.map((city) => ({...city,
          CityID: city.FromCityID,
          CityName: city.FromCity,
          BranchID: city.FromBranchId,
          BranchName: city.FromBranch,
        }))
        dispatch(updateReceiveDispatchCities(data))
      } else {
        dispatch(updateReceiveDispatchCities([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const getUpdateReceiveSelectVehicle = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequestCachedV3(urls.getVehilceList, data, isCache, cacheDuration)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateReceiveSelectVehicle(res))
      } else {
        dispatch(updateReceiveSelectVehicle([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getUpdateReceiveChallanNo = (loginData, data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.getReceiveDispatchChallanNo, {
    intCompanyID: loginData.intCompanyID,
    intFromCityID: data.FromCityID,
    intToCityID: data.intToCityID,
    dtJdate: data.dtJdate,
    intVehicleID: data.intVehicleID,
    intCurrentBranch: data.intCurrentBranch,
    intMode: 0,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        // res.Data.unshift({VoucherNo: "All"})
        dispatch(updateReceiveChallan(res))
      } else {
        dispatch(updateReceiveChallan([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}


export const getReceiveVehicleLoad = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequestCachedV3(urls.getVehilceList, data, isCache, cacheDuration)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateReceiveVehicleLoad(res))
      } else {
        dispatch(updateReceiveVehicleLoad([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getUpdateReceiveItemData = (loginData, data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getReceiveDataList, {
    intFromCityID: data.intFromCityID,
    intFromBranchID: data.intFromBranchID,
    intUserID: loginData.intUserID,
    intToCityID: data.intToCityID,
    intToBranchID: data.intToBranchID,
    intCompanyID: loginData.intCompanyID,
    dtFrom: data.dtFrom,
    dtTo: data.dtTo,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateReceiveItemData(res))
      } else {
        dispatch(updateReceiveItemData([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}


export const ReceiveGetLrList = (loginData, data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.getReceiveLrList, {
    strLRNO: data.strLRNO,
    intBookingID: 0,
    intCompanyID: loginData.intCompanyID,
    intBranchID: data.intBranchID,
    intUserID: loginData.intUserID,
    intBranchCityID: 1,
    intChallanNo: 0,
    intMode: 5,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === "Success") {
        dispatch(updateReceiveLRList(res))
      } else {
        dispatch(updateReceiveLRList([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const ReceiveLuggageToReceive = (loginData, data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getReceiveLuggageToReceive, {
    intBookingID: data.intBookingID,
    intCityID: data.intCityID,
    intBranchID: data.intBranchID,
    intCompanyID: loginData.intCompanyID,
    intMode: 2,
    strVehicleNo: data.strVehicleNo,
    intVehicleID: data.intVehicleID,
    intUserID: loginData.intUserID,
    Date: data.Date,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === "Success") {
        dispatch(updateLuggageToReceive(res))
      } else {
        dispatch(updateLuggageToReceive([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getReceiveUpdateReceive = (loginData, data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.getReceiveReceive, {
    intSendingCityID: data.intSendingCityID,
    strBookingIDs: data.strBookingIDs,
    intReceivedCityID: data.intReceivedCityID,
    intSendingBranchID: data.intSendingBranchID,
    intReceivedBranchID: data.intReceivedBranchID,
    strVehicleNo: data.strVehicleNo,
    strRemarks: data.strRemarks,
    intCompanyID: loginData.intCompanyID,
    intUserID: loginData.intUserID,
    VehicleID: data.VehicleID,
    strDispatchDetIDs: data.strDispatchDetIDs,
    strDipatchIDs: data.strDipatchIDs,
    strLRNos: data.strLRNos,
    strShortQtantities: data.strShortQtantities,
    strDamageQtys: data.strDamageQtys,
    strDispatchedVehicleNo: data.strDispatchedVehicleNo,
    intIsApp: 2,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(ReceiveUpdateReceive(res))
      } else {
        dispatch(ReceiveUpdateReceive(res))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getUpdateReceiveSecond = (loginData, data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.getReceiveSecond, {
    intCompanyID: loginData.intCompanyID,
    intUserID: loginData.intUserID,
    intNewCityID: data.intNewCityID,
    strBookingIDs: data.strBookingIDs,
    strDipatchIDs: data.strDipatchIDs,
    intNewBranchID: data.intNewBranchID,
    intIsApp: 2,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateReceiveSecond(res))
      } else {
        dispatch(updateReceiveSecond(res))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getReceiveLastReceivePrint = (data) => (dispatch) => {
  dispatch(updateReceiveLastReceivePrint(data))
}
export const getBranchReceiveLastReceivePrint = (data) => (dispatch) => {
  dispatch(updateBranchReceiveLastReceivePrint(data))
}

export const ResetStateOfBranchReceive = () => (dispatch) => {
  dispatch(updateShortReceive([]))
  dispatch(updateReceive([]))
  dispatch(updateReceiveSelectVehicle([]))
  dispatch(updateReceiveChallan([]))
  dispatch(ReceiveUpdateReceive([]))
  dispatch(updateReceiveLRList([]))
  dispatch(updateReceiveSecond([]))
}

// bottum color e0ffeefa before


export const getReceiveUpdateReceiveAllV2 = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.getReceiveInsertAllV2, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(ReceiveUpdateReceive(res))
      } else {
        dispatch(ReceiveUpdateReceive(res))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}